// src/features/designerStatsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const designerStatsSlice = createSlice({
  name: 'designerStats',
  initialState: {
    list: [],
    status: 'idle',
    error: null
  },
  reducers: {
    setDesignerStats: (state, action) => {
      console.log('Setting designer stat in slice:', action.payload);
      state.list = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    clearDesignerStats: (state) => {
      state.list = [];
      state.status = 'idle';
      state.error = null;
    }
  }
});

export const { setDesignerStats, setError, clearDesignerStats } = designerStatsSlice.actions;


export default designerStatsSlice.reducer;